import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";

import { SuccessScreen } from "@covertree/ui";

import { BASE_AUTH_PATH } from "../paths";

export default function CreateNewPasswordSuccess() {
  const navigate = useNavigate();
  const navigateToLogin = useCallback(() => {
    navigate(BASE_AUTH_PATH);
  }, [navigate]);

  const description = (
    <Typography
      mt={2}
      mb={4}
      variant="body1"
      sx={{
        color: "info.main",
      }}>
      Your password has been successfully changed. Please login with your new
      password.
    </Typography>
  );

  return (
    <SuccessScreen
      title="Password changed!"
      description={description}
      buttonLabel="Continue to login"
      action={navigateToLogin}
    />
  );
}
